var React = require('react');

function VSymbol (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_309","data-name":"Group 309","opacity":"0.12"},React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M404.518,798.141,151.118,84H348.056L513.921,604.584,679.789,84H874.83L624.2,798.518Z","transform":"translate(-151.118 -84)","fill":"#59b8fc"})));
}

VSymbol.defaultProps = {"width":"723.712","height":"714.518","viewBox":"0 0 723.712 714.518"};

module.exports = VSymbol;

VSymbol.default = VSymbol;
